// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const genderTypeSchema = z.enum(['M', 'F'])

export const relationshipTypeSchema = z.enum(['coniuge', 'figlio_figlia'])

export const baseRelativeSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  relationship: relationshipTypeSchema,
  fiscalCode: z.string(),
  taxDependent: z.boolean(),
})

export const relativeResponseSchema = baseRelativeSchema.extend({
  birthCity: z.string().optional(),
  birthDate: z.string().optional(),
  gender: genderTypeSchema.optional(),
})
